import { BRAND } from '../../theme/brandTokens';

export const FIELD_PLACEHOLDER_COLOR = '#999';

export const fieldLabelSx = {
  mb: 1,
  fontWeight: 600,
};

export const fieldLabelRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.25,
  mb: 1,
  minHeight: 24,
};

export const buildSelectFieldSx = (hasError = false) => ({
  height: '48px !important',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: hasError ? '#f44336' : BRAND.line,
    borderWidth: '2px !important',
    borderRadius: '8px !important',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: `${BRAND.accent} !important`,
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: `${BRAND.accent} !important`,
    borderWidth: '2px !important',
  },
  '&.Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: '#f44336 !important',
  },
  '& .MuiOutlinedInput-input': {
    padding: '12px 16px',
    fontSize: '16px',
  },
});

export const buildTextFieldSx = (hasError = false) => ({
  '& .MuiOutlinedInput-root': {
    height: 48,
    borderRadius: '8px',
    '& fieldset': {
      borderColor: hasError ? '#f44336' : BRAND.line,
      borderWidth: 2,
    },
    '&:hover fieldset': {
      borderColor: BRAND.accent,
    },
    '&.Mui-focused fieldset': {
      borderColor: BRAND.accent,
      borderWidth: 2,
    },
  },
  '& .MuiOutlinedInput-input': {
    padding: '12px 16px',
    fontSize: '16px',
  },
});

export const buildAdornmentTextFieldSx = (hasError = false) => ({
  ...buildTextFieldSx(hasError),
  '& .MuiOutlinedInput-root': {
    ...buildTextFieldSx(hasError)['& .MuiOutlinedInput-root'],
    paddingRight: 0,
    overflow: 'hidden',
  },
  '& .MuiInputAdornment-root': {
    height: '100%',
    maxHeight: 'none',
    margin: 0,
    paddingLeft: '14px',
    paddingRight: '14px',
    backgroundColor: BRAND.lineSoft,
    color: BRAND.textMuted,
    fontWeight: 600,
    fontSize: 16,
  },
});

export const nativeInputSx = (hasError = false, multiline = false) => ({
  width: '100%',
  padding: '12px 16px',
  border: `2px solid ${hasError ? '#f44336' : BRAND.line}`,
  borderRadius: '8px',
  fontSize: '16px',
  fontFamily: 'inherit',
  outline: 'none',
  transition: 'border-color 0.3s ease',
  backgroundColor: BRAND.surface,
  boxSizing: 'border-box',
  lineHeight: multiline ? 1.5 : 'normal',
  resize: multiline ? 'vertical' : 'none',
  minHeight: multiline ? 112 : 48,
  '&:focus': {
    borderColor: hasError ? '#f44336' : BRAND.accent,
  },
  '&:disabled': {
    backgroundColor: BRAND.background,
    cursor: 'not-allowed',
  },
});

export const inputWrapperSx = {
  '& input': {
    width: '100%',
    padding: '12px 16px',
    border: `2px solid ${BRAND.line}`,
    borderRadius: '8px',
    fontSize: '16px',
    fontFamily: 'inherit',
    outline: 'none',
    transition: 'border-color 0.3s ease',
    backgroundColor: BRAND.surface,
    boxSizing: 'border-box',
  },
  '& input::placeholder': {
    color: FIELD_PLACEHOLDER_COLOR,
    opacity: 1,
  },
  '& input:focus': {
    borderColor: BRAND.accent,
  },
  '& input.error': {
    borderColor: '#f44336',
  },
};
